(() => {
    const mobile = matchMedia("(max-width: 767px)");
    const products = document.getElementById("CollectionProducts");

    if (mobile.matches && products) {
        const header = document.querySelector("sticky-header");
        products.style.scrollMarginTop = `${(header?.clientHeight || 0) + 16}px`;
    }

    document.getElementById("MainContent")?.addEventListener("click", (event) => {
        if (!mobile.matches || event.defaultPrevented || event.button !== 0 ||
            event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const link = event.target.closest(
            ".multicolumn a[href], .collection__block--child-collections a[href], .collection-list-section a[href]"
        );
        if (!link || link.hasAttribute("download") ||
            (link.target && link.target !== "_self")) return;

        const url = new URL(link.href);
        if (url.origin !== window.location.origin || url.hash ||
            !/\/collections\/[^/]+\/?$/.test(url.pathname)) return;

        url.hash = "CollectionProducts";
        event.preventDefault();
        window.location.assign(url.href);
    });
})();
